import React from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'
import { rgba, stripUnit } from 'polished'
import { Link } from 'gatsby'

import { greyDark, white } from 'styles/colors'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

const Container = styled(Link)`
  display: block;
  text-align: center;
  background-color: ${greyDark};
  border-top: 1px solid ${rgba(white, 0.1)};
  padding: ${spacing.small} ${spacing.large};
  color: ${white};

  ${media.small`
    padding: ${stripUnit(spacing.small) * 1.5 + 'px'};
  `};
`

const Message = styled.small`
  display: block;
`

const Announcement = ({ message, link }) => {
  if (!link) {
    return (
      <Container as="div">
        <Message>{message}</Message>
      </Container>
    )
  }

  return (
    <Container to={link}>
      <Message>{message}</Message>
    </Container>
  )
}

Announcement.propTypes = {
  message: string.isRequired,
  link: string
}

export default Announcement
